export const caresourcerHomeUrl = 'https://www.caresourcer.com';

export const regulatorCountries = {
  ci: 'Scotland',
  cqc: 'England',
} as { [key: string]: string };

export const directoryBasePath = '/directory';
